import styled from '@emotion/styled';
import MuiOpenInNewIcon from '@material-ui/icons/OpenInNew';

import colors from '$variables/colors';
import { spacing, typography } from '$variables/theme';

export const Link = styled.a`
  color: ${colors.purpleHeart};
  font-weight: ${typography.fontWeightSemiBold};
  text-decoration: none;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const Text = styled.div`
  margin-right: ${spacing.xSmall};
`;

export const OpenInNewIcon = styled(MuiOpenInNewIcon)`
  width: 18px;
  height: 18px;
`;
